import { LocationType } from '../types';

export const TooltipFeatureType = {
  COUNTRY: 1,
  METRO_AREA: 2,
  CITY: 3,
  STATE: 4,
  COUNTY: 5,
} as const;

const CODE_BY_LOCATION_TYPE: Record<LocationType, number> = {
  [LocationType.REGION]: 0,
  [LocationType.COUNTRY]: TooltipFeatureType.COUNTRY,
  [LocationType.METRO_AREA]: TooltipFeatureType.METRO_AREA,
  [LocationType.CITY]: TooltipFeatureType.CITY,
  [LocationType.STATE]: TooltipFeatureType.STATE,
  [LocationType.COUNTY]: TooltipFeatureType.COUNTY,
};

export const tooltipFeatureTypeForLocation = (
  locationType: LocationType
): number => CODE_BY_LOCATION_TYPE[locationType] ?? 0;
